import { useState } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid'
import ResumeView from './InterventionResume'
import ShowView from './InterventionShow'

export default ({ item }) => {
  const [view, setView] = useState('resume')

  const toggleView = () => {
    setView(view === 'resume' ? 'show' : 'resume')
  }

  return (
    <div className="relative mb-2 w-full">
      {view === 'resume' ? (
        <ResumeView intervention={item} />
      ) : (
        <ShowView intervention={item} />
      )}
      <div className="absolute top-4 right-4 flex flex-col items-center">
        <button
          onClick={toggleView}
          className="btn btn-sm btn-ghost btn-square hover:bg-primary-400"
          title={view === 'resume' ? 'Voir les détails' : 'Masquer les détails'}
        >
          {view === 'resume' ? <ChevronDownIcon /> : <ChevronUpIcon />}
        </button>
      </div>
    </div>
  )
}